import React from 'react';
import PropTypes from 'prop-types';
import styles from './QuizProgressBarV3.css';

function QuizProgressBarV3({ slides, currentSlideIndex }) {
    const segments = [];

    slides.forEach(slide => {
        const category = slide.props?.category;

        if (!category) {
            return;
        }

        const existingSegment = segments.find(segment => segment.category === category);

        if (existingSegment) {
            existingSegment.count += 1;
        } else {
            const offset = segments.reduce((sum, segment) => sum + segment.count, 0);

            segments.push({ category, count: 1, offset });
        }
    });

    return (
        <div className={styles.root}>
            {segments.map(segment => {
                const progress = Math.min(100, Math.max(0, ((currentSlideIndex - segment.offset) / segment.count) * 100));

                return (
                    <div key={`${segment.category}-${segment.offset}`} className={styles.segment}>
                        <div className={styles.fill} style={{ width: `${progress}%` }} />
                    </div>
                );
            })}
        </div>
    );
}

QuizProgressBarV3.propTypes = {
    slides: PropTypes.array,
    currentSlideIndex: PropTypes.number
};

QuizProgressBarV3.defaultProps = {
    slides: [],
    currentSlideIndex: 0
};

export {
    QuizProgressBarV3
};
